import { ImgHuman1, ImgHuman2, ImgHuman3, ImgHuman4 } from '@/assets';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const SectionHuman = () => {
  const { t } = useTranslation();
  const sectionRef = useRef<HTMLDivElement>(null);
  const [sticky, setSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      if (rect.top < 0) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <>
      <div className="section-human" ref={sectionRef}>
        <div
          className="info-section"
          style={{
            position: sticky ? 'sticky' : 'relative',
            top: 0,
            left: 0,
          }}
        >
          <p className="title-top">{t('Let us help you turn your ideas into reality.')}</p>
          <p className="title-section__content">{t('Human resources')}</p>
          <div className="title-section__bottom">
            <p className="text-purple">{t('Our Expertise')}</p>
            <p>
              {t(
                'We are a trusted partner delivering high-quality, cost-efficient, and innovative software solutions through proven processes and a dynamic, agile team.'
              )}
            </p>
          </div>
        </div>
        <div className="list-card">
          <div className="card-box card-1">
            <img src={ImgHuman1} alt="human-1" width={437} height={474} />
            <p className="title-card">{t('Software Development Team')}</p>
          </div>
          <div className="card-box card-2">
            <img src={ImgHuman2} alt="human-2" width={437} height={474} />
            <p className="title-card">{t('Algorithm Research Team')}</p>
          </div>
          <div className="card-box card-3">
            <img src={ImgHuman3} alt="human-3" width={437} height={474} />
            <p className="title-card">{t('Project Management Team')}</p>
          </div>
          <div className="card-box card-4">
            <img src={ImgHuman4} alt="human-4" width={437} height={474} />
            <p className="title-card">{t('ConSulting Team')}</p>
          </div>
        </div>
      </div>
      <div className="section-human-mobile">
        <div>
          <p className="title">{t('Human resources')}</p>
          <div
            className="desc"
            dangerouslySetInnerHTML={{
              __html: t(
                'Our customers inspire everything we do. We serve a diverse community, tailoring solutions to meet their unique needs and drive their success.'
              ),
            }}
          ></div>
        </div>
        <div className="card-box card-1">
          <img src={ImgHuman1} alt="human-1" width={343} height={474} />
          <p className="title-card">{t('Software Development Team')}</p>
        </div>
        <div className="card-box card-2">
          <img src={ImgHuman2} alt="human-2" width={343} height={474} />
          <p className="title-card">{t('Algorithm Research Team')}</p>
        </div>
        <div className="card-box card-3">
          <img src={ImgHuman3} alt="human-3" width={343} height={474} />
          <p className="title-card">{t('Project Management Team')}</p>
        </div>
        <div className="card-box card-4">
          <img src={ImgHuman4} alt="human-4" width={343} height={474} />
          <p className="title-card">{t('ConSulting Team')}</p>
        </div>
      </div>
    </>
  );
};

export default React.memo(SectionHuman);
